import { type ForgeUIExtensionType } from '@atlassian/forge-ui-types';

export const getIsCustomUI = (extension: ForgeUIExtensionType) => {
	const { properties } = extension;
	return !!properties.resource && properties.render !== 'native';
};
